var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('div',{staticClass:"edume-more"},[(_vm.moreContentMessage)?_c('span',{staticClass:"edume-more-content-message"},[_vm._v(_vm._s(_vm.moreContentMessage))]):_vm._e(),_c('a',{class:[
          'edume-see-all-link',
          {'edume-is-full-width': !_vm.moreContentMessage},
          'edume-link' ],attrs:{"href":_vm.dashboardUrl,"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.linkText)+" ")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }